import { render, staticRenderFns } from "./DeliveryNoteItemForm.vue?vue&type=template&id=2187aa4c&scoped=true&"
import script from "./DeliveryNoteItemForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteItemForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNoteItemForm.vue?vue&type=style&index=0&id=2187aa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187aa4c",
  null
  
)

export default component.exports